function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 12c1.933 0 3.5-1.343 3.5-3V7c0-1.657-1.567-3-3.5-3S8.5 5.343 8.5 7v2c0 1.657 1.567 3 3.5 3zm-1.167-5c0-.553.522-1 1.167-1s1.167.447 1.167 1v2c0 .552-.522 1-1.167 1s-1.167-.448-1.167-1V7zm4.667 7h-7C6.567 14 5 15.343 5 17v2c0 .552.521 1 1.167 1 .645 0 1.166-.448 1.166-1v-2c0-.553.522-1 1.167-1h7c.645 0 1.167.447 1.167 1v2c0 .552.521 1 1.166 1C18.48 20 19 19.552 19 19v-2c0-1.657-1.567-3-3.5-3z"
});

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.b8c459f2.svg";
export { ForwardRef as ReactComponent };